// シマーアニメーションによるスケルトンローダーの共通クラス。
export const SHIMMER_BAR_CLASS =
  'animate-shimmer bg-[linear-gradient(90deg,#f0f0f0_25%,#e0e0e0_50%,#f0f0f0_75%)] bg-[length:200%_100%]';
